const TextToSpeech = () => {
  const defs = {
    selectors: {
      tts: ".js-tts",
      headerTop: ".header__container-top",
      playBtn: "#playbutton",
      pauseBtn: "#pausebutton",
      stopBtn: "#stopbutton",
      rateSelect: "#rateSelect",
      scrollCheckbox: "#scrollCheckbox",
      playbackInfo: "#playback-information",
    },
    classes: {
      ttsActive: "tts-active",
      hidden: "hidden",
    },
    vars: {},
  };

  const init = () => {
    if (typeof window.initializeTts !== "function") {
      console.warn("TTS library not loaded");
      return;
    }

    document.querySelectorAll(defs.selectors.tts).forEach((btn) => {
      btn.addEventListener("click", () => {
        activateTts();
        btn.blur();
        initTts();
      });
    });
  };

  function activateTts() {
    document.body.classList.add("tts-active");

    const headerTop = document.querySelector(defs.selectors.headerTop);
    if (headerTop) {
      const placeholder = document.createElement("div");
      placeholder.className = "tts-placeholder";
      placeholder.style.height = `${headerTop.offsetHeight}px`;
      headerTop.parentNode.insertBefore(placeholder, headerTop.nextSibling);
    }
  }

  function initTts() {
    let playBtn = document.querySelector(defs.selectors.playBtn);
    let pauseBtn = document.querySelector(defs.selectors.pauseBtn);
    let stopBtn = document.querySelector(defs.selectors.stopBtn);
    let rateSlt = document.querySelector(defs.selectors.rateSelect);
    let scrollCkb = document.querySelector(defs.selectors.scrollCheckbox);

    if (!playBtn) {
      return; // TTS controls not present on this page
    }

    let playEventListener = null;
    let pauseEventListener = null;
    let stopEventListener = null;
    let rateEventListener = null;
    let scrollEventListener = null;

    window.initializeTts({
      rootElement: document.querySelector(".layout"),
      additionalIncludeSelector: "a, summary",
      fallbackToEnglishIfPreferredLanguageIsMissing: true,
      renderControls: (props) => {
        // Play button
        if (playEventListener) {
          playBtn.removeEventListener("click", playEventListener);
        }

        playEventListener = () => {
          playBtn.classList.add(defs.classes.hidden);
          pauseBtn.classList.remove(defs.classes.hidden);
          pauseBtn.focus();
          props.play();
        };
        playBtn.addEventListener("click", playEventListener);

        // Pause button
        if (pauseEventListener) {
          pauseBtn.removeEventListener("click", pauseEventListener);
        }

        pauseEventListener = () => {
          playBtn.classList.remove(defs.classes.hidden);
          pauseBtn.classList.add(defs.classes.hidden);
          playBtn.focus();
          props.pause();
        };
        pauseBtn.addEventListener("click", pauseEventListener);

        // Stop button
        if (stopEventListener) {
          stopBtn.removeEventListener("click", stopEventListener);
        }

        stopEventListener = () => {
          playBtn.classList.remove(defs.classes.hidden);
          pauseBtn.classList.add(defs.classes.hidden);
          playBtn.focus();
          props.stop();
        };
        stopBtn.addEventListener("click", stopEventListener);

        // Rate select
        if (rateEventListener) {
          rateSlt.removeEventListener("change", rateEventListener);
        }

        rateEventListener = props.setRate;
        rateSlt.addEventListener("change", (event) => {
          rateEventListener(event.target.value);
        });

        // Scroll checkbox
        if (scrollEventListener) {
          scrollCkb.removeEventListener("change", scrollEventListener);
        }

        scrollEventListener = () => {
          props.setScrollEnabled(!props.scrollEnabled);
        };

        scrollCkb.addEventListener("change", scrollEventListener);

        // Update playback information
        updateVoiceAvailabilityText(props.voiceAvailability);
        updateIssueFlagsText(props.issueFlags);
      },
    });
  }

  function updateVoiceAvailabilityText(voiceAvailability) {
    let playbackInformationEl = document.querySelector(defs.selectors.playbackInfo);
    let voiceAvailabilityEl = document.getElementById("voice-availability");

    if (voiceAvailability !== "all" && !voiceAvailabilityEl) {
      voiceAvailabilityEl = document.createElement("p");
      voiceAvailabilityEl.id = "voice-availability";
      playbackInformationEl?.prepend(voiceAvailabilityEl);
    }

    if (voiceAvailability === "none") {
      voiceAvailabilityEl.innerHTML = "Voice is missing for the content.";
    } else if (voiceAvailability === "some") {
      voiceAvailabilityEl.innerHTML = "Voice is missing for some parts of the content.";
    } else if (voiceAvailability === "some-with-fallback") {
      voiceAvailabilityEl.innerHTML =
        "Some parts of the content will be read with an English as you don't have voices installed for their native language.";
    }

    if (voiceAvailability == "all" && voiceAvailabilityEl) {
      voiceAvailabilityEl.remove();
    }
  }

  function updateIssueFlagsText(issueFlags) {
    let playbackInformationEl = document.querySelector(defs.selectors.playbackInfo);
    let textSelectionIssueEl = document.getElementById("text-selection-issue");

    if (issueFlags.textSelection && !textSelectionIssueEl) {
      textSelectionIssueEl = document.createElement("p");
      textSelectionIssueEl.id = "text-selection-issue";
      playbackInformationEl?.appendChild(textSelectionIssueEl);
      textSelectionIssueEl.innerHTML =
        "On iPhone and iPad you have to mark any text on the site to be able to visually follow during playback.";
    }

    let speechBoundaryUpdatesIssueEl = document.getElementById("speech-boundary-issue");

    if (issueFlags.speechBoundaryUpdates && !speechBoundaryUpdatesIssueEl) {
      speechBoundaryUpdatesIssueEl = document.createElement("p");
      playbackInformationEl?.appendChild(speechBoundaryUpdatesIssueEl);
      speechBoundaryUpdatesIssueEl.id = "speech-boundary-issue";
      speechBoundaryUpdatesIssueEl.innerHTML =
        "Visual updates during playback is unfortunately not supported in Android or Chrome in iOS.";
    }
  }

  return {
    init,
  };
};

export default TextToSpeech;
